import {Directive, HostListener, ElementRef, Input, Renderer2} from '@angular/core';

//for ths directive to be implemented please add libGroupSkip [groupSkipContent]="true" as an id to your HTML elements
//if Element is not interactive you can add tabIndex="0" to make it focusable
@Directive({
  standalone: true,
  selector: '[libGroupSkip]',
})
export class GroupSkipDirective {
  @Input() set groupSkipContent(value: boolean) {
    this.renderer.setAttribute(this.el.nativeElement, 'groupSkipContent', value.toString());
  }
  groups!: NodeListOf<Element>;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  @HostListener('keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent): void {
    this.groups = document.querySelectorAll('[groupSkipContent="true"]');
    let activeGroup: number = this.getFocusedGroupIndex();
    if (event.shiftKey && event.key === 'F6') {
      event.preventDefault();
      const prevIndex = --activeGroup;
      (this.groups[prevIndex] as HTMLElement).focus();
    } else if (event.key === 'F6') {
      event.preventDefault();
      const nextIndex = ++activeGroup;
      (this.groups[nextIndex] as HTMLElement).focus();
    }
  }

  private getFocusedGroupIndex(): number {
    const elements = document.querySelectorAll('[groupSkipContent="true"]');
    let focusedIndex = -1;

    elements.forEach((element, index) => {
      if (element === document.activeElement) {
        focusedIndex = index;
      }
    });
    return focusedIndex;
  }
}
